import React from 'react';
import { Bell, Calendar, User } from 'lucide-react';
import { formatRoleName, formatNotificationDate } from '../utils/notificationUtils';
import type { Notification } from '../types/notification.types';

interface NotificationMetadataProps {
  notification: Notification;
}

export const NotificationMetadata: React.FC<NotificationMetadataProps> = ({
  notification,
}) => {
  const { formattedDate, formattedTime } = formatNotificationDate(notification.createdAt);

  return (
    <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground mb-2">
      <div className="flex items-center gap-1">
        <span className="font-medium">
          {notification.notificationType?.name}
        </span>
      </div>
      
      <div className="flex items-center gap-1">
        <Calendar className="h-4 w-4 text-gray-400" />
        <span>
          {formattedDate} {formattedTime}
        </span>
      </div>
      
      <div className="flex items-center gap-1">
        <User className="h-4 w-4 text-gray-400" />
        <span>
          {notification.createdByUser?.firstName}{" "}
          {notification.createdByUser?.lastName}
        </span>
      </div>
      
      <div className="flex items-center gap-1">
        <Bell className="h-4 w-4 text-gray-400" />
        <span>
          <span className="font-medium">Origen:</span> {formatRoleName(notification.originUserRole)}
        </span>
      </div>
      
      <div className="flex items-center gap-1">
        <Bell className="h-4 w-4 text-gray-400" />
        <span>
          <span className="font-medium">Destino:</span> {formatRoleName(notification.targetUserRole)}
        </span>
      </div>
    </div>
  );
}; 